export const environment = {
  useNamLogin: true,
  baseUrl: '.',
  baseInd: 'claims-platform',
  callbackPath: 'sw00543-iban-check/callback',
  logoutPath: 'https://claims-platform.generali.it',
  nam: {
    urlAuthz: "https://loginidm.generali.it/nidp/oauth/nam/authz",
    urlToken: "https://loginidm.generali.it/nidp/oauth/nam/token",
    urlEndSession: 'https://loginidm.generali.it/nidp/oauth/v1/nam/end_session',
    clientId: "dbd3aec7-872e-4463-b210-f0af4b27d419",
    redirectUri: "https://claims-platform.generali.it/sw00543-iban-check/callback",
    scope: "srv://app/APP-1229"
  },
  smartSummaryWebGedHost: "http://webged.generali.it:9083/gs/mostradocumentoIG.asp?app=RCA&DOCID=null&username=90000185&porta=80&CATID=223450961&ProtGED=",
};

